import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

import { StyledEditor } from './styles';

const TextEditor = forwardRef(({
  value,
  onChange,
  onChangeSelection,
  placeholder,
}, ref) => (
  <StyledEditor
    ref={ref}
    value={value}
    onChange={onChange}
    onChangeSelection={onChangeSelection}
    placeholder={placeholder}
    modules={{
      toolbar: [
        [{ header: [1, 2, 3, 4, false] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ indent: '-1' }, { indent: '+1' }],
        [{ align: [] }],
        ['link', 'image'],
      ],
    }}
  />
));

TextEditor.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onChangeSelection: PropTypes.func,
  placeholder: PropTypes.string,
};

TextEditor.defaultProps = {
  onChangeSelection: undefined,
  placeholder: undefined,
};

TextEditor.displayName = 'TextEditor';

export default TextEditor;
